import WalletSelect from './WalletSelect/WalletSelect';
import AccountLabel from './AccountLabel';

const AccountSelect = ({accounts, value, onChange, placeholder = '— select —', isClearable = false, excludeId}) => {
    const filtered = excludeId != null
        ? accounts.filter(a => String(a.id) !== String(excludeId))
        : accounts;

    const options = filtered.map(a => ({value: a.id, account: a}));
    const selected = options.find(o => String(o.value) === String(value)) ?? null;

    return (
        <WalletSelect
            options={options}
            value={selected}
            onChange={opt => onChange(opt ? String(opt.value) : '')}
            placeholder={placeholder}
            isClearable={isClearable}
            formatOptionLabel={opt => <AccountLabel account={opt.account}/>}
        />
    );
};

export default AccountSelect;